import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {sortableHandle} from "react-sortable-hoc";

import {updateContractsList} from "./contractsActions";
import CheckBox from "../PageLayout/CheckBox";
import contractInterface from "./contractInterface";
import MaterialsIcons from "../Icons/MaterialsIcons";

const DragHandle = sortableHandle(() => <span className="drag-handle"/>);

const ContractsListItem = (props) => {

  const {contract, contractsList, updateContractsList} = props;

  const selectClick = () => {
    updateContractsList(contractsList.map(cont => {
      return (cont.id === contract.id) ? Object.assign({}, cont, {
        selected: !contract.selected
      }) : cont
    }));
  }

  const contractClick = (event) => {
    if (event.target.closest(".fs-toggle-popup__table-col--drag")) {
      return
    }
    updateContractsList(contractsList.map(cont => {
      return Object.assign({}, cont, {
        isActive: cont.id === contract.id
      })
    }));
  }

  const defaultClick = () => {
    updateContractsList(contractsList.map(cont => {
      return Object.assign({}, cont, {
        isDefault: cont.id === contract.id ? !contract.isDefault : false
      })
    }));
  }

  const downloadClick = () => {
    if (!contract.documentUrl) {
      return
    }
    let tempLink = document.createElement('a');
    tempLink.href =contract.documentUrl;
    tempLink.setAttribute('download', contract.name);
    tempLink.setAttribute('target', '_blank');
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }

  return (
    <div className="fs-toggle-popup__table-row bordered flex--center">
      <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--drag">
        <DragHandle/>
      </div>
      <div
        className="fs-toggle-popup__table-col fs-toggle-popup__table-col--check">
        <CheckBox checked={contract.selected}
                  innerStyle="none"
                  type={"medium"}
                  disabled={false}
                  onChecked={selectClick}
                  text=""/>
      </div>
      <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--check">
        <span className={"ui-star " + (contract.isDefault ? "ui-star--active" : "ui-star--gray")}
              onClick={defaultClick}/>
      </div>
      <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--check">
        <span className={"ui-button5__material-icon link"
          + (contract.documentUrl ? " ui-button5__material-icon--blue" : " ui-button5__material-icon--gray2")}
              onClick={downloadClick}>{MaterialsIcons.DownloadIcon}</span>
      </div>
      <div className={"fs-toggle-popup__table-col fs-toggle-popup__table-col--name noselect link text-left"
        + (contract.isActive ? " color-green" : " color-blue")} onClick={contractClick}>
        {contract.name}
      </div>
    </div>
  )
};

ContractsListItem.propTypes = {
  contract: PropTypes.shape(contractInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {contractsList} = store.contractsState;
  return {
    contractsList,
  }
};

const mapDispatchToProps = {
  updateContractsList,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractsListItem)
